export default {
  PRE_PRIMARY: {
    PE: "Physical Fitness and Health",
    LANGUAGE: "Language",
    MATHS: "Early Mathematics",
    SCIENCE: "Science and Technology",
    SOCIETY: "Self and Society",
    ARTS: "Arts",
  },
  PRIMARY: {
    CHINESE: "Chinese Language Education",
    ENGLISH: "English Language Education",
    MATHS: "Mathematics Education",
    SOCIETY:
      "General Studies for Primary Schools: Personal, Social and Humanities Education",
    SCIENCE: "General Studies for Primary Schools: Science Education",
    TECHNOLOGY: "General Studies for Primary Schools: Technology Education",
    ARTS: "Arts Education",
    PE: "Physical Education",
    CIVIC: "Moral and Civic Education",
    READING: "Reading to Learn",
  },
  SECONDARY: {
    CHINESE: "Chinese Language Education",
    ENGLISH: "English Language Education",
    MATHS: "Mathematics Education",
    BIOLOGY: "Science Education: Biology",
    CHEMISTRY: "Science Education: Chemistry",
    PHYSICS: "Science Education: Physics",
    IS: "Science Education: Integrated Science",
    CS: "Science Education: Combined Science",
    TECHNOLOGY: "Technology Education",
    BUSINESS:
      "Technology Education: Business, Accounting and Financial Studies",
    CHINESE_HISTORY:
      "Personal, Social and Humanities Education: Chinese History",
    ECONOMICS: "Personal, Social and Humanities Education: Economics",
    RELIGION:
      "Personal, Social and Humanities Education: Religious Studies / Ethics and Religious Studies",
    GEOGRAPHY: "Personal, Social and Humanities Education: Geography",
    HISTORY:
      "Personal, Social and Humanities Education: History and Culture / History",
    SOCIETY: "Personal, Social and Humanities Education: Life and Society",
    HUMANITIES:
      "Personal, Social and Humanities Education: Integrated Humanities",
    TOURISM:
      "Personal, Social and Humanities Education: Tourism and Hospitality Studies",
    MUSIC: "Arts Education: Music",
    ARTS: "Arts Education: Visual Arts",
    PE: "Physical Education",
    LIBERAL: "Liberal Studies",
    READING: "Reading to Learn",
    OTHERS: "Other Learning Experience",
    APPLIED: "Applied Learning",
  },
  TERTIARY: {},
  SPECIAL: {
    BASIC: {
      CHINESE: "(BEC) Chinese Language Education",
      ENGLISH: "(BEC) English Language Education",
      MATHS: "(BEC) Mathematics Education",
      SOCIETY:
        "(BEC) General Studies for Primary Schools: Personal, Social and Humanities Education",
      SCIENCE: "(BEC) General Studies for Primary Schools: Science Education",
      TECHNOLOGY:
        "(BEC) General Studies for Primary Schools: Technology Education",
      ARTS: "(BEC) Arts Education",
      PE: "(BEC) Physical Education",
      CIVIC: "(BEC) Moral and Civic Education",
      READING: "(BEC) Reading to Learn",
    },
    SENIOR: {
      CHINESE: "(SSC) Chinese Language Education",
      ENGLISH: "(SSC) English Language Education",
      MATHS: "(SSC) Mathematics Education",
      BIOLOGY: "(SSC) Science Education: Biology",
      CHEMISTRY: "(SSC) Science Education: Chemistry",
      PHYSICS: "(SSC) Science Education: Physics",
      IS: "(SSC) Science Education: Integrated Science",
      CS: "(SSC) Science Education: Combined Science",
      TECHNOLOGY: "(SSC) Technology Education",
      BUSINESS:
        "(SSC) Technology Education: Business, Accounting and Financial Studies",
      CHINESE_HISTORY:
        "(SSC) Personal, Social and Humanities Education: Chinese History",
      ECONOMICS: "(SSC) Personal, Social and Humanities Education: Economics",
      RELIGION:
        "(SSC) Personal, Social and Humanities Education: Religious Studies / Ethics and Religious Studies",
      GEOGRAPHY: "(SSC) Personal, Social and Humanities Education: Geography",
      HISTORY:
        "(SSC) Personal, Social and Humanities Education: History and Culture / History",
      SOCIETY:
        "(SSC) Personal, Social and Humanities Education: Life and Society",
      HUMANITIES:
        "(SSC) Personal, Social and Humanities Education: Integrated Humanities",
      TOURISM:
        "(SSC) Personal, Social and Humanities Education: Tourism and Hospitality Studies",
      MUSIC: "(SSC) Arts Education: Music",
      ARTS: "(SSC) Arts Education: Visual Arts",
      PE: "(SSC) Physical Education",
      LIBERAL: "(SSC) Liberal Studies",
      READING: "(SSC) Reading to Learn",
      OTHERS: "(SSC) Other Learning Experience",
      APPLIED: "(SSC) Applied Learning",
    },
    BASIC_ID: {
      CHINESE: "(ID: BEC) Chinese Language",
      MATHS: "(ID: BEC) Mathematics",
      GENERAL: "(ID: BEC) General Studies",
      TECHNOLOGY: "(ID: BEC) Technology Education",
      APPLIED: "(ID: BEC) Adapted Applied Learning Courses",
    },
    SENIOR_ID: {
      CHINESE: "(ID: SSC) Chinese Language",
      MATHS: "(ID: SSC) Mathematics",
      LIBERAL: "(ID: SSC) Liberal Studies/Independent Living",
      PE: "(ID: SSC) Physical Education",
      ARTS: "(ID: SSC) Visual Arts",
      IT: "(ID: SSC) Information and Communication Technology",
      TECHNOLOGY: "(ID: SSC) Technology and Living",
      MUSIC: "(ID: SSC) Music",
      DESIGN: "(ID: SSC) Design and Applied Technology",
      RELIGION: "(ID: SSC) Ethics and Religious Studies",
      HEALTH: "(ID: SSC) Health Management and Social Care",
      APPLIED: "(ID: SSC) Adapted Applied Learning Courses",
    },
  },
};
